<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer un nouveau groupe SIREN</strong>
          </div>
          <b-form>
            <b-form-group label="Libellé" label-for="libelle">
              <b-form-input
                id="libelle"
                type="text"
                :class="{hasError: errors.libelle !== ''}"
                v-model="libelle"
              />
              <span class="field-error">{{ errors.libelle }}</span>
            </b-form-group>
            <b-form-group label="Type" label-for="type">
              <b-form-input
                id="type"
                type="text"
                :class="{hasError: errors.type !== ''}"
                v-model="type"
              />
              <span class="field-error">{{ errors.type }}</span>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des groupes
              </b-button>
              <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card no-body>
          <b-card-header>
            <i class="fa fa-list mr-2"></i>
            <strong>Attacher siren(s)</strong>
          </b-card-header>
          <b-card-body>
            <div class="flex-box">
              <b-form-group class="child--featured">
                <b-form-input
                  placeholder="Raison Sociale"
                  id="raison"
                  type="text"
                  :class="{hasError: errors.raisonSociale !== ''}"
                  v-model="raisonSociale"
                />
              </b-form-group>
              <b-button
                class="search-btn"
                type="button"
                @click="search"
                size="sm"
                variant="primary">
                Recherche
              </b-button>
            </div>
            <div class="p-2">
              <b-form-group v-if="sirensReady">
                <b-form-checkbox-group class="pl-3" v-model="checkedSirens">
                  <b-row>
                    <b-form-checkbox v-for="element in sirens"
                                     :value="element.siren"
                                     :key="element.id">
                      {{ element.siren }} ({{ element.raison_sociale || 'RS non renseignée' }})
                    </b-form-checkbox>
                  </b-row>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
            <b-form-group>
              <label for="sirenList"><strong>SIREN(s) : </strong></label>
              <b-form-textarea id="sirenList"
                               v-model="sirenList"
                               placeholder="Entrer siren séparé par ;">
              </b-form-textarea>
            </b-form-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "Add",
    data() {
      return {
        sirenList: '',
        sirens: [],
        raisonSociale: '',
        sirensReady: false,
        checkedSirens: [],
        libelle: "",
        type: "",
        errors: {
          raisonSociale: "",
          libelle: "",
          type: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      save() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.type = this.type;
          dataPost.sirens = this.checkedSirens;
          dataPost.insertedSirens = this.getInsertedSirens();
          this.$axios
            .post("/espaceQualite/groupes-siren", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "Le groupe SIREN a été bien crée ",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack();
            })
            .catch(() => {
              this.handleErrors();
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/groupes-siren"});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.libelle === "") {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        if (this.type === "") {
          this.errors.type = "Le type est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter un administrateur',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      search() {
        this.sirens = [];
        if (this.raisonSociale !== '') {
          this.$store.commit("IS_LOADING", true);
          const dataPost = {
            raison_sociale: this.raisonSociale,
          };
          this.$axios
            .post("/espaceQualite/sirens", dataPost)
            .then((response) => {
              this.$store.commit("IS_LOADING", false);
              if (response.data.sirens.length > 0) {
                this.sirensReady = true;
                this.sirens = response.data.sirens;
              }
            })
        }
      },
      getInsertedSirens() {
        return this.sirenList.split(';').filter(element => element.trim() !== '');
      }
    }
  }
</script>
<style scoped>
  .flex-box {
    display: flex;
    justify-content: space-between;
  }
  .search-btn {
    margin-bottom: 1rem;
  }

  .child--featured {
    flex-basis: 80%;
  }
</style>

